import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { numberFormatter } from '../../components/formatters/numberFormatter';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import { Table } from 'antd';
import { toWords } from 'number-to-words';




const ComponentToPrint = React.forwardRef((props, ref) => {
  const { journalVoucher, vatAmount, isUsingMainCurrency,
    mainCurrency,
    secondaryCurrency, selectedCompany, secondaryVatAmount } = props;

  let cartColumns;

  const costTypes = ['PurchaseInvoice', 'PurchaseReturn', 'PurchaseOrder'];   



  if (costTypes.includes(journalVoucher?.type)) {
    cartColumns = [
      { title: 'Product', dataIndex: 'product', width: 200, render: (product) => (product?.name) },
      { title: 'Quantity', dataIndex: 'quantity', render: numberFormatter },
      { title: 'FreeQuantity', dataIndex: 'freeQuantity', render: numberFormatter },
      { title: 'NetQuantity', dataIndex: 'netQuantity', render: numberFormatter },
      { title: 'Cost', dataIndex: 'cost', render: numberFormatter },
      { title: 'Discount', dataIndex: 'costDiscountPercentage', render: numberFormatter },
      { title: 'NetCost', dataIndex: 'netCost', render: numberFormatter },
      { title: 'VAT', dataIndex: 'vatAmount', render: numberFormatter },
      Table.EXPAND_COLUMN,
    ];
  } else {
    cartColumns = [
      { title: 'Product', dataIndex: 'product', width: 200, render: (product) => (product?.name) },
      { title: 'Unit', dataIndex: 'unitName', render: (unitName, record) => (unitName + ' (' + record.unitQuantity + ')') },
      { title: 'Price', dataIndex: 'price', render: numberFormatter },
      { title: 'Discount', dataIndex: 'costDiscountPercentage', render: numberFormatter },
      { title: 'NetQuantity', dataIndex: 'netQuantity', render: numberFormatter },
      { title: 'NetPrice', dataIndex: 'netPrice', render: numberFormatter },
      { title: 'Quantity', dataIndex: 'netQuantity', render: numberFormatter },
      { title: 'TotalPrice', dataIndex: 'totalPrice', render: numberFormatter },
      { title: 'VAT', dataIndex: 'vatAmount', render: numberFormatter },
      Table.EXPAND_COLUMN,
    ];
  }


  return (
    <div ref={ref} style={{ padding: '20px', fontFamily: 'Arial, sans-serif', color: '#333' }}>

      <Row className='mb-5'>
      </Row>
      {/* Info Section */}
      <div style={{ marginBottom: '20px', lineHeight: '1.8' }}>

     <Row>
        <Col md={1}></Col>
        <Col md={8}>
          <h2 style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
            {journalVoucher?.company?.name}
          </h2>
        </Col>
        <Col>
         <h2 style={{ fontSize: '1.2rem' }}>
            {journalVoucher?.type === 'Receipt'
              ? 'Receipt'
              : journalVoucher?.type === 'Payment'
              ? 'Payment'
              : 'Invoice'}
          </h2>
        </Col>
      </Row>



        <Row>
          <Col md={1}>
          </Col>
          <Col md={8}>
            Reg: {journalVoucher?.company?.registrationNumber}
          </Col>
          <Col>
            ID: {journalVoucher?.myId}
          </Col>
        </Row>


        <Row>
          <Col md={1}>
          </Col>
          <Col md={8}>
            {journalVoucher?.company?.address}
          </Col>
          <Col>
            Ref: {journalVoucher?.id}
          </Col>
        </Row>

        <Row>
          <Col md={1}>
          </Col>
          <Col>{journalVoucher?.company?.phone}
          </Col>
        </Row>
      </div>



      <Row>
        <Col md={1}>
        </Col>
       
        <Col>
          Date: {journalVoucher?.date}
          
        </Col>
      </Row>

      <Row>
        <Col md={1}></Col>
        <Col>Billed To: {journalVoucher?.account?.english}</Col>
      </Row>


      <Row>
        <Col md={1}> 
     
        </Col>
     
       
        <Col md={8}>
          Reg: {journalVoucher?.account?.registration}
        </Col>
        <Col>
        </Col>
      </Row>


      <Row>
        <Col md={1}>
        </Col>
        <Col md={8}>
          {journalVoucher?.account?.address}
        </Col>
        <Col>
        </Col>
      </Row>


      <Row>
        <Col md={1}>
        </Col>
        <Col md={8}>
          {journalVoucher?.account?.phone}
        </Col>
        <Col>
        </Col>
      </Row>



      <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', color: '#333', marginBottom: '10%' }}>
        {/* Table Section */}
        {journalVoucher?.cart?.length > 0 && (
          
          <Table
            columns={cartColumns}
            dataSource={journalVoucher?.cart}
            pagination={false}
            expandable={{
              expandedRowRender: (record) => (
                <p style={{ margin: 0, color: '#119FE2' }}>{record.details}</p>
              ),
              rowExpandable: (record) => !!record.details, // Only allow rows with details to be expandable
            }}
          />
        )}
      </div>


      <Row>
        <Col md={6}></Col>
        <Col md={2}>Discount: {journalVoucher?.discountPercentage}%</Col>
        <Col>{numberFormatter(journalVoucher?.discountAmount)} {mainCurrency?.symbol}</Col>
        <Col>{numberFormatter(journalVoucher?.secondaryDiscountAmount)} {secondaryCurrency?.symbol}</Col>
      </Row>

      <Row className='mb-1'>
        <Col md={6}></Col>
        <Col md={2}>Vat 11%</Col>
        <Col>{numberFormatter(vatAmount)}</Col>
        <Col>{numberFormatter(secondaryVatAmount)}</Col>
      </Row>

      <Row className='mb-5'>
        <Col md={6}></Col>
        <Col md={2} style={{fontWeight: 'bold'}}>Total</Col>
        <Col style={{fontWeight: 'bold'}}>{numberFormatter(journalVoucher?.totalDebit)} {mainCurrency?.symbol}</Col>
        <Col style={{fontWeight: 'bold'}}>{numberFormatter(journalVoucher?.secondaryTotalDebit)} {secondaryCurrency?.symbol}</Col>
      </Row>


      <Row>
        <Col md={7}>Total: {toWords(journalVoucher?.totalDebit)}</Col>
        <Col md={1}></Col>
        <Col>Currency: {journalVoucher?.currency?.code || '-'}</Col>
        <Col> Rate: {numberFormatter(journalVoucher?.currency?.rate)}</Col>
      </Row>

      <Row>
        <Col md={1}></Col>
      </Row>

    </div>


  );
});

export default ComponentToPrint;